import React from 'react';

const InsightsCard = () => {
    return (
        <>Insights</>
    );
};

export default InsightsCard;
